import { render } from "./TransmissionLogModal.vue?vue&type=template&id=c367ed68&scoped=true"
import script from "./TransmissionLogModal.vue?vue&type=script&lang=ts"
export * from "./TransmissionLogModal.vue?vue&type=script&lang=ts"

import "./TransmissionLogModal.vue?vue&type=style&index=0&id=c367ed68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c367ed68"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QTable,QTr,QTh,QTd,QChip,QSpace});qInstall(script, 'directives', {ClosePopup});
